"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsageError = exports.assertUsage = void 0;
var createError_1 = require("./createError");
function assertUsage(assertion, errorMessage) {
    if (assertion) {
        return;
    }
    throw getUsageError(errorMessage);
}
exports.assertUsage = assertUsage;
function getUsageError(errorMessage) {
    var errMsg = "[Wrong Usage]";
    if (errorMessage) {
        errMsg += " " + errorMessage;
    }
    var err = createError_1.createError(errMsg);
    return err;
}
exports.getUsageError = getUsageError;
//# sourceMappingURL=assertUsage.js.map